import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const ThumbnailSelection = ({ selectedEnvelope = {}, changeThumbnailSettings = () => { }, selectedVideo }) => {
    const THUMBNAIL_TYPE_STATIC = 0;
    const THUMBNAIL_TYPE_ANIMATED = 1;
    const ENVELOPE_VAL = 2;
    const [thumbnailType, setThumbnailType] = useState(selectedVideo.thumbnail_type);
    const handleRadioButtonChange = (e) => {
        const value = e.currentTarget.value;
        setThumbnailType(value);
        changeThumbnailSettings(value);
    };

    useEffect(() => {
        if (selectedVideo) {
            setThumbnailType(selectedVideo.thumbnail_type);
        }
    }, [selectedVideo]);

    return (
        <>
            <div id="pv-thumbnail-options" className='input-field radio-field' style={{ display: 'flex', justifyContent: 'center' }}>
                <div>
                    <input
                        id='static-button-input'
                        className='tv-radio-button'
                        type='radio'
                        name="static-button-input"
                        value={0}
                        checked={thumbnailType.toString() === THUMBNAIL_TYPE_STATIC.toString()}
                        onChange={handleRadioButtonChange}
                    />
                    <label
                        id="static-button-label"
                        htmlFor='static-button-input'
                        className='inline-block cursor-pointer margin-r-24px'>
                        Static Thumbnail
                    </label>
                </div>

                <div>
                    <input
                        id='animated-button-input'
                        className='tv-radio-button'
                        type='radio' name="animated-button-input"
                        value={1}
                        checked={thumbnailType.toString() === THUMBNAIL_TYPE_ANIMATED.toString()}
                        onChange={handleRadioButtonChange}
                    />
                    <label
                        id="animated-button-label"
                        htmlFor='animated-button-input'
                        className='inline-block cursor-pointer margin-r-24px'>
                        Animated Thumbnail
                    </label>
                </div>

                <div>
                    <input
                        id='envelope-button-input'
                        className='tv-radio-button'
                        type='radio' name="envelope-button-input"
                        value={2}
                        checked={thumbnailType.toString() === ENVELOPE_VAL.toString()}
                        onChange={handleRadioButtonChange}
                    />
                    <label
                        id="envelope-button-label"
                        htmlFor='envelope-button-input'
                        className='inline-block cursor-pointer margin-r-24px'>
                        Envelope
                    </label>

                    {
                        thumbnailType.toString() === ENVELOPE_VAL.toString() && <div style={{ color: '#696A72' }}>{selectedEnvelope?.name}</div>
                    }
                </div>
            </div>
        </>
    );
};

ThumbnailSelection.propTypes = {
    selectedEnvelope: PropTypes.object,
    selectedVideo: PropTypes.object,
    changeThumbnailSettings: PropTypes.func,
};

export default ThumbnailSelection;
